import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/addJobs';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Add sync jobs for the chosen tables of an existing source.
function* operation(action) {
  const { sourceId, tables, import_historical } = action.payload;
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/add-jobs/${sourceId}`,
      { tables, import_historical },
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(res.data?.data || res.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
